export default __webpack_public_path__ + "static/media/KOOMIO.9c8d2f33.png";